if (!customElements.get('py-order-flow')) {
  customElements.define('py-order-flow', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.py-order-flow__track');
      if (!track) return;
      const cards = [...track.children];
      const steps = [...this.querySelectorAll('[data-step]')];
      const dots = [...this.querySelectorAll('.py-order-flow__dots span')];
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const abort = new AbortController();
      let current = 0, frame;
      const sync = () => {
        const x = track.getBoundingClientRect().left;
        current = cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - x) < Math.abs(cards[best].getBoundingClientRect().left - x) ? i : best, 0);
        steps.forEach((button, i) => i === current ? button.setAttribute('aria-current', 'step') : button.removeAttribute('aria-current'));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
        prev.disabled = current === 0;
        next.disabled = current === cards.length - 1;
      };
      const go = i => {
        i = Math.max(0, Math.min(cards.length - 1, i));
        track.scrollTo({left: track.scrollLeft + cards[i].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      steps.forEach((button, i) => button.addEventListener('click', () => go(i), {signal: abort.signal}));
      prev.addEventListener('click', () => go(current - 1), {signal: abort.signal});
      next.addEventListener('click', () => go(current + 1), {signal: abort.signal});
      track.addEventListener('scroll', () => {cancelAnimationFrame(frame); frame = requestAnimationFrame(sync);}, {passive:true,signal:abort.signal});
      const resize = new ResizeObserver(sync); resize.observe(track);
      this.querySelectorAll('[hidden]').forEach(el => el.hidden = false);
      this.setAttribute('data-ready', ''); sync();
      this.cleanup = () => {abort.abort();resize.disconnect();cancelAnimationFrame(frame);this.removeAttribute('data-ready');};
    }
    disconnectedCallback() {this.cleanup?.();this.cleanup = null;}
  });
}
